module.exports = __webpack_public_path__ + "img/oppeln.e5faa209.jpg";